import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=6cc1941a&scoped=true&"
import script from "./terms.vue?vue&type=script&lang=js&"
export * from "./terms.vue?vue&type=script&lang=js&"
import style0 from "./terms.vue?vue&type=style&index=0&id=6cc1941a&lang=scss&scoped=true&"
import style1 from "./terms.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./terms.vue?vue&type=style&index=2&id=6cc1941a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc1941a",
  null
  
)

export default component.exports